/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filter } from 'lodash';

import PropTypes from 'prop-types';
import requireAuth from '../../components/hocs/requireAuth';
import PostScoreForm from '../../components/PostScoreForm';
import PickleballPostScoreForm from '../../components/PostScoreForm/PickleballPostScoreForm';

import { hideSplash } from '../../actions/splash-actions';
import { ballTypeIds, divisionFormatTypeIds, drawPositionTypeIds } from '../../utils/eventConstants';
import { isPickleBallSportTypeEvent, isEventType, EventTypes } from '../../utils/events';
import { showErrorPopup } from '../../actions/notification-actions';
import styles from './postScore.scss';

const _ = { filter };

const EventPostScoreFormWrapper = ({
    history,
    externalSaveClick,
    setExternalSaveClick,
    event,
    drawsDict, // v1
    selectedDrawId, // v1
    draw, // v2
    players,
    playersDict,
    playersDictByMemberId,
    teams,
    teamsDict,
    roundIndex,
    activeRound,
    defaultMatchIndex,
    setParentMatchIndex,
    setParentIsDoubles,
    closeWithoutSaving,
    redirectOnFinish,
    isDualMatch,
    matches,
    drawIndex,
    childDrawIndex,
    isInPopup,
    postEventScore,
    showExitButton,
    isExpanded,
    'data-testid': dataTestId,
}) => {
    const user = useSelector(({ auth }) => auth.user);
    const dispatch = useDispatch();

    const { timeZone, maxResultDateUtc } = event.eventSchedule;
    const isVerified = event.utrTypeId === 2 || event.utrType?.id === 2;
    const isPickleballEvent = isPickleBallSportTypeEvent(event?.sportTypeId);

    const [matchIndex, setMatchIndex] = useState(null);
    const [match, setMatch] = useState(null);
    const [isFirstMatch, setIsFirstMatch] = useState(null);
    const [isLastMatch, setIsLastMatch] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isDinglesMatch, setIsDinglesMatch] = useState(drawsDict?.[selectedDrawId]?.formatTypeId === divisionFormatTypeIds.DINGLES || draw?.formatTypeId === divisionFormatTypeIds.DINGLES);
    const [isColorball] = useState(draw?.ballTypeId !== null && draw?.ballTypeId > ballTypeIds.YELLOW);

    useEffect(() => {
        const match = matches[matchIndex || defaultMatchIndex];
        if (match) {
            setMatch(populateMatchPlayers(match, isDualMatch));
            if (matchIndex === null) {
                setMatchIndex(defaultMatchIndex);
                setIsFirstMatch(defaultMatchIndex === 0);
                setIsLastMatch(defaultMatchIndex === matches.length - 1);
            }
            if (setParentIsDoubles) {
                setParentIsDoubles(match.position1.type?.value === 'team' || match.position1.typeId === drawPositionTypeIds.TEAM);
            }
            if (match.drawId) {
                if (drawsDict[match.drawId]?.formatTypeId === divisionFormatTypeIds.DINGLES) {
                    setIsDinglesMatch(true);
                }
            }
        }
    }, [matches]);

    const populateMatchPlayers = (match, isDualMatch) => { // TODO: add team profile images to players in v2?
        let pos1player1; let pos1player2;
        let pos2player1; let pos2player2;
        let team1; let team2;
        let team1Players; let team2Players;
        const team1PlayerIds = []; const team2PlayerIds = [];

        if (isDualMatch) {
            if (!teams[0].isHome) {
                team1 = teams[0];
                team2 = teams[1];
            } else {
                team1 = teams[1];
                team2 = teams[0];
            }
            team1Players = _.filter(players, { eventTeamDetail: { clubId: team1.clubId } });
            team2Players = _.filter(players, { eventTeamDetail: { clubId: team2.clubId } });
            team1Players.forEach(player => {
                team1PlayerIds.push(player.id || player.playerId);
            });
            team2Players.forEach(player => {
                team2PlayerIds.push(player.id || player.playerId);
            });
        }

        const getPlayerTeamProfileImage = (playerId) => {
            let clubProfileImages = false;
            if (team1PlayerIds.includes(parseInt(playerId))) {
                clubProfileImages = team1.clubProfileImages;
            } else if (team2PlayerIds.includes(parseInt(playerId))) {
                clubProfileImages = team2.clubProfileImages;
            }
            return clubProfileImages;
        };

        const updatePlayerWithTeamProfileImage = (player) => {
            const clubProfileImages = getPlayerTeamProfileImage(player.id || player.playerId);
            return {
                ...player,
                clubProfileImages,
            };
        };

        // v1
        if (match.position1.type?.value === 'player') {
            pos1player1 = playersDict[match.position1.id];
        } else if (match.position1.type?.value === 'team') {
            pos1player1 = playersDict[teamsDict[match.position1.id].players[0]];
            pos1player2 = playersDict[teamsDict[match.position1.id].players[1]];
        }
        if (match.position2.type?.value === 'player') {
            pos2player1 = playersDict[match.position2.id];
        } else if (match.position2.type?.value === 'team') {
            pos2player1 = playersDict[teamsDict[match.position2.id].players[0]];
            pos2player2 = playersDict[teamsDict[match.position2.id].players[1]];
        }

        // v2
        if (match.position1.typeId === drawPositionTypeIds.PLAYER) {
            pos1player1 = playersDictByMemberId[match.position1.memberId];
        } else if (match.position1.typeId === drawPositionTypeIds.TEAM) {
            pos1player1 = playersDictByMemberId[teamsDict[match.position1.teamId].members[0]];
            pos1player2 = playersDictByMemberId[teamsDict[match.position1.teamId].members[1]];
        }

        if (match.position2.typeId === drawPositionTypeIds.PLAYER) {
            pos2player1 = playersDictByMemberId[match.position2.memberId];
        } else if (match.position2.typeId === drawPositionTypeIds.TEAM) {
            pos2player1 = playersDictByMemberId[teamsDict[match.position2.teamId].members[0]];
            pos2player2 = playersDictByMemberId[teamsDict[match.position2.teamId].members[1]];
        }
        match.pos1player1 = isDualMatch ? updatePlayerWithTeamProfileImage(pos1player1) : pos1player1;
        if (pos1player2) {
            match.pos1player2 = isDualMatch ? updatePlayerWithTeamProfileImage(pos1player2) : pos1player2;
        }
        match.pos2player1 = isDualMatch ? updatePlayerWithTeamProfileImage(pos2player1) : pos2player1;
        if (pos2player2) {
            match.pos2player2 = isDualMatch ? updatePlayerWithTeamProfileImage(pos2player2) : pos2player2;
        }
        return match;
    };

    const handlePostClick = async (data, direction) => {
        if (setExternalSaveClick) {
            setExternalSaveClick(false);
        }

        try {
            setIsSaving(true);
            if (event) {
                if (data) {
                    if (isInPopup) {
                        await dispatch(postEventScore(data, match.drawId || selectedDrawId));
                    } else {
                        await dispatch(postEventScore(data, { drawIndex, childDrawIndex, roundIndex, matchIndex }, event.id));
                    }
                    setIsSaving(false);
                } else {
                    setIsSaving(false);
                    console.log('Score hasn\'t been updated, not saving...');
                }

                if (direction === 'next' && !isLastMatch) {
                    loadNextMatch();
                } else if (direction === 'prev') {
                    loadPrevMatch();
                } else if (redirectOnFinish) {
                    if (isEventType(event, EventTypes.DUAL_MATCH) || isEventType(event, EventTypes.TEAM_MATCH)) {
                        history.push(`/events/${event.id}`);
                    } else if (selectedDrawId) {
                        history.push(`/events/${event.id}/draws?d=${selectedDrawId}&r=${activeRound || 0}`);
                    } else {
                        history.push(`/events/${event.id}/draws`);
                    }
                } else {
                    closeWithoutSaving();
                }
            }
        } catch (err) {
            setIsSaving(false);
            dispatch(showErrorPopup({
                message: 'Post Score Failed!',
                error: err,
                showSupportLink: true,
            }));
        }
    };

    const loadNextMatch = () => {
        let match;
        if (matches && matchIndex < matches.length - 1) {
            // eslint-disable-next-line no-plusplus
            for (let i = matchIndex + 1; i < matches.length; i++) {
                match = matches[i];
                if (match.position1?.id && match.position1.type?.value !== 'bye' && match.position1.typeId !== drawPositionTypeIds.BYE &&
                    match.position2?.id && match.position2.type?.value !== 'bye' && match.position2.typeId !== drawPositionTypeIds.BYE) {
                    dispatch(hideSplash());

                    setMatch(populateMatchPlayers(match, isDualMatch));
                    setMatchIndex(i);
                    if (setParentMatchIndex) {
                        setParentMatchIndex(i);
                    }
                    setIsFirstMatch(i === 0);
                    setIsLastMatch(i === matches.length - 1);
                    break;
                    // if first match is bye, still disable the next button
                } else if (i === matches.length - 1) {
                    closeWithoutSaving();
                }
            }
        }
    };

    const loadPrevMatch = () => {
        // SAVE CURRENT MATCH
        let match;
        if (matches && matchIndex > 0) {
            // eslint-disable-next-line no-plusplus
            for (let i = matchIndex - 1; i >= 0; i--) {
                match = matches[i];
                if (match.position1?.id && match.position1.type?.value !== 'bye' && match.position1.typeId !== drawPositionTypeIds.BYE &&
                    match.position2?.id && match.position2.type?.value !== 'bye' && match.position2.typeId !== drawPositionTypeIds.BYE) {
                    dispatch(hideSplash());

                    setMatch(populateMatchPlayers(match, isDualMatch));
                    setMatchIndex(i);
                    if (setParentMatchIndex) {
                        setParentMatchIndex(i);
                    }
                    setIsFirstMatch(i === 0);
                    setIsLastMatch(i === matches.length - 1);
                    break;
                    // if first match is bye, still disable the prev button
                } else if (i === 0) {
                    dispatch(hideSplash());
                    setIsFirstMatch(true);
                }
            }
        }
    };

    let popupTitle;
    if (roundIndex) {
        popupTitle = `Round ${roundIndex + 1} - Match ${matchIndex + 1}`;
    } else if (isDualMatch) {
        popupTitle = `${(match?.position1.type?.value === 'team' || match?.position1.typeId === drawPositionTypeIds.TEAM ? 'Doubles ' : 'Singles ') + (matchIndex + 1)}`;
    } else {
        popupTitle = `Match ${matchIndex + 1}`;
    }

    return match ? (
        <div>
            {isInPopup && (
                <>
                    <div className={`mt4 ${styles.matchTitle}`} data-testid={dataTestId ? `${dataTestId}.match-title` : undefined}>
                        {popupTitle}
                    </div>
                    <hr className={`${styles.divider}`} />
                </>
            )}
            {isPickleballEvent || isDinglesMatch ? (
                <PickleballPostScoreForm
                    externalSaveClick={externalSaveClick}
                    user={user}
                    matchObj={match}
                    isEvent={true}
                    isEdit={true}
                    maxResultDateUtc={maxResultDateUtc}
                    timeZone={timeZone}
                    handlePostClick={handlePostClick}
                    isFirstMatch={isFirstMatch}
                    isLastMatch={isLastMatch}
                    teamsDict={teamsDict}
                    playersDictByMemberId={playersDictByMemberId}
                    defaultVerifiedResultTo={isVerified}
                    clubTierType={event.club?.clubTierType || event.club?.tierType || event.club?.tierTypeId}
                    isDualMatch={isDualMatch}
                    event={event}
                    isInPopup={isInPopup}
                    showExitButton={showExitButton}
                    isSaving={isSaving}
                    isDingles={isDinglesMatch}
                    isExpanded={isExpanded}
                />
            ) : (
                <PostScoreForm
                    externalSaveClick={externalSaveClick}
                    user={user}
                    matchObj={match}
                    isEvent={true}
                    isEdit={true}
                    maxResultDateUtc={maxResultDateUtc}
                    timeZone={timeZone}
                    handlePostClick={handlePostClick}
                    isFirstMatch={isFirstMatch}
                    isLastMatch={isLastMatch}
                    teamsDict={teamsDict}
                    playersDictByMemberId={playersDictByMemberId}
                    defaultVerifiedResultTo={isVerified}
                    clubTierType={event.club?.clubTierType || event.club?.tierType || event.club?.tierTypeId}
                    isDualMatch={isDualMatch}
                    event={event}
                    isInPopup={isInPopup}
                    showExitButton={showExitButton}
                    isSaving={isSaving}
                    isColorball={isColorball}
                    sportTypeId={event?.sportTypeId}
                    isTimeBasedDraw={draw?.isTimeBased || false}
                    isExpanded={isExpanded}
                />
            )}
        </div>
    ) : null;
};

EventPostScoreFormWrapper.propTypes = {
    event: PropTypes.shape().isRequired,
};

export default requireAuth(EventPostScoreFormWrapper);
